import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export class ApPincodeValidator {
    public static validate(control: AbstractControl): ValidationErrors {
        return Validators.compose([Validators.pattern(/^\d*$/i), Validators.minLength(5), Validators.maxLength(5)])(control);
    }
}
